import { BoxSlotTemplateFormView } from "@/modules/boxSlotTemplate/components/boxSlotTemplateFormView"

type BoxSlotTemplateFormCreateProps = {
  boxProgramId: string
  dateToCreateSlotTemplateOn: Date
  className?: string
} & React.ComponentProps<"div">

export const BoxSlotTemplateFormCreate = ({
  boxProgramId,
  dateToCreateSlotTemplateOn,
  className,
  ...props
}: BoxSlotTemplateFormCreateProps) => {
  return (
    <BoxSlotTemplateFormView
      boxSlotTemplate={null}
      boxProgramId={boxProgramId}
      dateToCreateSlotTemplateOn={dateToCreateSlotTemplateOn}
      className={className}
      {...props}
    />
  )
}
